export type AppRole =
  | 'fan'
  | 'player'
  | 'coach'
  | 'club_owner'
  | 'scout'
  | 'scouter'
  | 'referee'
  | 'medical_staff'
  | 'venue_owner'
  | 'tournament_organizer'
  | 'team_manager'
  | 'admin'
  | 'super_admin'
  | 'club_admin'
  | 'club_manager'
  | 'club_finance'
  | 'parent';

export const ALL_ROLES: AppRole[] = [
  'fan',
  'player',
  'coach',
  'club_owner',
  'scout',
  'scouter',
  'referee',
  'medical_staff',
  'venue_owner',
  'tournament_organizer',
  'team_manager',
  'admin',
  'super_admin',
  'club_admin',
  'club_manager',
  'club_finance',
  'parent'
];

export const ROLE_GROUPS = {
  base: ['fan'] as AppRole[],
  professional: [
    'club_owner',
    'coach',
    'player',
    'scout',
    'scouter',
    'referee',
    'medical_staff',
    'venue_owner',
    'tournament_organizer',
    'team_manager',
  ] as AppRole[],
  admin: ['admin', 'super_admin'] as AppRole[],
};

export const formatRoleName = (role: AppRole) =>
  role
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

/** Real dashboard paths. Roles without their own route stay on /dashboard. */
export const ROLE_DASHBOARD: Record<AppRole, string> = {
  fan: '/dashboard',
  player: '/player/dashboard',
  coach: '/coach/dashboard',
  club_owner: '/owner/dashboard',
  scout: '/scout/dashboard',
  scouter: '/scouter/dashboard',
  referee: '/referee/dashboard',
  medical_staff: '/medical/dashboard',
  venue_owner: '/venue/dashboard',
  tournament_organizer: '/organizer/dashboard',
  team_manager: '/team-manager/dashboard',
  admin: '/admin/dashboard',
  super_admin: '/super/dashboard',
  club_admin: '/dashboard',
  club_manager: '/dashboard',
  club_finance: '/dashboard',
  parent: '/dashboard',
};

/**
 * Signed-in accounts with no active role row are fans. handle_new_user grants
 * fan, and the fan home is the fallback when no role is stored.
 */
export function withImplicitFan(roles: AppRole[]): AppRole[] {
  const known = roles.filter((role) => ALL_ROLES.includes(role));
  return known.length > 0 ? known : ["fan"];
}

export const defaultDashboardFor = (roles: AppRole[], activeRole?: AppRole | null) => {
  if (activeRole && roles.includes(activeRole)) return ROLE_DASHBOARD[activeRole];
  if (roles.includes('super_admin')) return ROLE_DASHBOARD.super_admin;
  if (roles.includes('admin')) return ROLE_DASHBOARD.admin;
  const first = roles[0];
  return first ? ROLE_DASHBOARD[first] : '/dashboard';
};
